import { Divider } from '@nextui-org/react';
import styled from 'styled-components';

import { Input } from '..';

interface ItemsProps {
  $top?: number;
}
export const Items = styled.div.attrs<ItemsProps>(({ $top }) => ({
  style: {
    top: `${$top}px`,
  },
}))<ItemsProps>`
  background-color: ${({ theme }) => theme.colors.neutrals.c700};
  box-shadow: 0px 8px 16px rgba(22, 22, 22, 0.2), 0px 3px 10px rgba(22, 22, 22, 0.3);
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 1rem;
  position: fixed;
  z-index: 99999;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    position: static;
    border: unset;
    padding: 0;
    box-shadow: none;
    background-color: ${({ theme }) => theme.colors.neutrals.c800};
  }
`;

export const Item = styled.div`
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  white-space: nowrap;

  svg {
    stroke: ${({ theme }) => theme.colors.neutrals.c300};
  }
`;

export const ItemContainer = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 2;
  gap: 1rem;
  height: 2rem;
  justify-content: space-between;
`;

export const ItemText = styled.span`
  color: ${({ theme }) => theme.colors.neutrals.c050};
  font-size: ${({ theme }) => theme.fontVariants.desktop.body.sm.fontSize};
  line-height: ${({ theme }) => theme.fontVariants.desktop.body.sm.lineHeight};
`;

export const ItemDescription = styled(ItemText)`
  color: ${({ theme }) => theme.colors.neutrals.c300};
`;

export const Separator = styled(Divider)`
  background-color: ${({ theme }) => theme.colors.primary.c050};
`;

export const BottomSheetContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const LeftSideContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledInput = styled(Input)<{ $noMargin?: boolean }>`
  margin-bottom: ${(props) => (props.$noMargin ? '0' : undefined)};
`;
